import { Building2, ChevronsUpDown } from 'lucide-react';
import { useLibrary } from '@/lib/library';
import { useI18n } from '@/lib/i18n';
import { Menu } from '@/components/ui/Menu';

/** Which branch am I working at? Persisted; defaults to the user's home library. */
export function LibrarySwitcher() {
  const { libraries, current, setCurrentId } = useLibrary();
  const { t } = useI18n();
  if (!current) {
    return null;
  }
  const trigger = (
    <button
      type="button"
      className="flex max-w-[14rem] items-center gap-2 rounded-lg border border-line bg-surface px-2.5 py-1.5 text-sm font-medium text-ink shadow-card transition hover:border-sapphire-300"
      aria-label={`${t('shell.library')}: ${current.name}`}
    >
      <Building2 className="h-4 w-4 shrink-0 text-sapphire-600 dark:text-sapphire-300" aria-hidden="true" />
      <span className="truncate">{current.name}</span>
      {libraries.length > 1 && <ChevronsUpDown className="h-3.5 w-3.5 shrink-0 text-ink-subtle" aria-hidden="true" />}
    </button>
  );
  if (libraries.length <= 1) {
    return (
      <div className="flex max-w-[14rem] items-center gap-2 rounded-lg border border-line bg-surface px-2.5 py-1.5 text-sm font-medium text-ink shadow-card">
        <Building2 className="h-4 w-4 shrink-0 text-sapphire-600 dark:text-sapphire-300" aria-hidden="true" />
        <span className="truncate">{current.name}</span>
      </div>
    );
  }
  return (
    <Menu
      label={t('shell.switchLibrary')}
      trigger={trigger}
      placement="bottom-end"
      items={[
        { type: 'label', label: t('shell.switchLibrary') },
        ...libraries.map((l) => ({ id: String(l.id), label: l.name, checked: l.id === current.id, onSelect: () => setCurrentId(l.id) })),
      ]}
    />
  );
}
